module.exports = __webpack_public_path__ + "static/media/header2.18677843.gif";